import { Link } from "react-router-dom";

interface CategoryEntry {
  type: string;
  label: string;
  icon: string;
  desc: string;
  count: number;
}

interface CategoryEntriesProps {
  entries: CategoryEntry[];
}

const accentStyles = [
  "bg-primary-500 text-background-50",
  "bg-accent-500 text-background-50",
  "bg-secondary-500 text-background-50",
];

export default function CategoryEntries({ entries }: CategoryEntriesProps) {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      {entries.map((entry, i) => (
        <Link
          key={entry.type}
          to={`/category/${entry.type}`}
          className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 hover:bg-background-100"
        >
          <span
            className={`flex h-14 w-14 shrink-0 items-center justify-center rounded-lg ${accentStyles[i % accentStyles.length]}`}
          >
            <i className={`${entry.icon} text-2xl`}></i>
          </span>
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <h3 className="font-heading text-lg font-semibold text-foreground-950">
                {entry.label}
              </h3>
              <span className="rounded-md bg-secondary-100 px-1.5 py-0.5 text-xs text-secondary-700">
                {entry.count} 部
              </span>
            </div>
            <p className="mt-1 text-sm text-foreground-600">{entry.desc}</p>
          </div>
          <i className="ri-arrow-right-line text-secondary-400 transition-transform group-hover:translate-x-1 group-hover:text-primary-600"></i>
        </Link>
      ))}
    </div>
  );
}